import React from 'react';
import { Building2, Ruler, Video } from 'lucide-react';

const OPCIONES = [
  { id: 'atelier', titulo: 'En el Atelier', detalle: 'Te esperamos en el atelier para tomar tus medidas.', Icono: Building2 },
  { id: 'videollamada', titulo: 'Por videollamada', detalle: 'Te guiamos paso a paso para tomarlas desde casa.', Icono: Video },
];

export default function MedidasCoordinacion({ valor, onCambiar }) {
  return (
    <div className="space-y-3 rounded-2xl border border-[#27272A] bg-[#18181B] p-5" data-testid="medidas-coordinacion">
      <div className="flex items-center gap-2">
        <Ruler className="h-4 w-4 text-[#C9A962]" />
        <h4 className="text-sm font-medium text-white">¿Cómo deseas coordinar la toma de medidas?</h4>
      </div>
      <div className="grid gap-3 sm:grid-cols-2">
        {OPCIONES.map(({ id, titulo, detalle, Icono }) => (
          <button key={id} type="button" onClick={() => onCambiar(id)} aria-pressed={valor === id}
            className={`flex gap-3 rounded-xl border-2 p-4 text-left transition-colors ${valor === id ? 'border-[#C9A962] bg-[#C9A962]/5' : 'border-[#27272A] hover:border-zinc-600'}`}
            data-testid={`medidas-${id}`}>
            <Icono className="mt-0.5 h-5 w-5 shrink-0 text-[#C9A962]" />
            <span>
              <span className="block text-sm font-medium text-white">{titulo}</span>
              <span className="block text-xs text-zinc-400">{detalle}</span>
            </span>
          </button>
        ))}
      </div>
    </div>
  );
}
